export const CONSTANTS = {
    APP_TITLE: 'Contributor Engagement'
}